export const USER_ROLE_OPERATOR = 1;
export const USER_ROLE_AGENCY = 2;
export const USER_ROLE_COMPANY = 3;
export const USER_ROLE_STAFF = 4;

export const USER_TYPE_OWNER = 1;
export const USER_TYPE_IP_SUPPORT = 5;
export const USER_PERMISION_ONWER = 'owner';
